// Nature-inspired color palette for charts
export const chartColors = {
  // Primary palette for categories
  primary: [
    '#4A7C59', // sage
    '#6B9080', // mint
    '#3D5A80', // ocean
    '#98C1D9', // sky
    '#C9B79C', // sand
    '#A67C52', // clay
    '#1D4A2D', // forest-dark
    '#2D5A3D', // forest
    '#3D6B4C', // forest-light
    '#8B8589', // stone
  ],

  // Semantic colors
  income: '#4CAF50',
  expense: '#EF5350',
  neutral: '#8B8589',

  // Gradient pairs for area charts
  gradients: {
    forest: { start: '#4A7C59', end: '#6B9080' },
    ocean: { start: '#3D5A80', end: '#98C1D9' },
    earth: { start: '#A67C52', end: '#C9B79C' },
  },
};

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatCurrencyCompact(value: number): string {
  if (Math.abs(value) >= 1000000) {
    return `$${(value / 1000000).toFixed(1)}M`;
  }
  if (Math.abs(value) >= 1000) {
    return `$${(value / 1000).toFixed(1)}K`;
  }
  return formatCurrency(value);
}

export function formatPercent(value: number): string {
  return `${value.toFixed(1)}%`;
}

export function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function formatMonth(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { month: 'short', year: '2-digit' });
}
